import Player from './Player';

interface PremiumState {
    isActive?: boolean;
    expireDate?: Date;
}

interface ChatBanState {
    isActive?: boolean;
    expireDate?: { date: string } | null;
}

interface ChatState {
    ban: ChatBanState;
    channel?: number;
}

export default class User {
    public id!: number;
    public username!: string;
    public isAdmin!: boolean;
    public isOnline!: boolean;
    public premium: PremiumState = {};
    public chat: ChatState = { ban: {} };
    public player: Player = new Player();
    public ignoredUsers: User[] = [];
    public friends: User[] = [];

    public static fromData(data: any): User {
        const user = new User();
        user.id = data.id;
        user.username = data.username;
        user.isAdmin = data.is_admin;
        user.isOnline = data.is_online;
        user.premium = {
            isActive: data.premium.is_active,
            expireDate: new Date(data.premium.expire_date),
        };
        user.chat = {
            ban: {
                isActive: data.chat.ban.is_active,
                expireDate: data.chat.ban.expire_date,
            },
            channel: data.chat.channel,
        };

        if (data.player) {
            user.player = Player.fromData(data.player.data);
        }

        if (data.ignored_users) {
            user.ignoredUsers = data.ignored_users.data.map((ignoredUser: any) => User.fromData(ignoredUser));
        }

        if (data.friends) {
            user.friends = data.friends.data.map((friend: any) => User.fromData(friend));
        }

        return user;
    }

    public isPremium(): boolean {
        if (!this.premium.isActive) {
            return false;
        }

        return this.premium.isActive;
    }
}
